import * as React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import  Login from "./components/login/login";
import Dashboard from './components/layouts/index';
//import ManifiestoconFecha from './components/siee/reporteManifiesto'; 
function App() {
      //  localStorage.clear();

  const token = localStorage.getItem('idUsuario');
  if (!token) {
    return <BrowserRouter>
    <Routes>
      <Route path='/' exact element={<Login />} />
    </Routes>
  </BrowserRouter>
  }
  else{
    return <BrowserRouter>
    <Routes>
      <Route path='/'  element={<Dashboard />} />
    </Routes>
  </BrowserRouter>
  }
   

}
export default App;